import { render, staticRenderFns } from "./widgetReview.vue?vue&type=template&id=4b564c63&scoped=true&"
import script from "./widgetReview.vue?vue&type=script&lang=js&"
export * from "./widgetReview.vue?vue&type=script&lang=js&"
import style0 from "./widgetReview.vue?vue&type=style&index=0&id=4b564c63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b564c63",
  null
  
)

export default component.exports